
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gKJfeWON4CV16XEE_usPzj_K_45VNmzNOr23cXvFF_bH04Meta } from "/codebuild/output/src2003172521/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexxBBRea73dEazcdObYcEF5_acvLpki8mL6oDOWC2_45YDAMeta } from "/codebuild/output/src2003172521/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search8jKb1drQagor4gfJiEQi1ITIyivsykp9dujah84ZaAQMeta } from "/codebuild/output/src2003172521/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexqyDVkMTUQ0fmznxZfCc5ZdiCiNlG5l6XmAo1_UlNRFsMeta } from "/codebuild/output/src2003172521/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93mJYwuSMzRbKiNTfdvoHPzJUNSkPS6b0GFhwmf_R5KtQMeta } from "/codebuild/output/src2003172521/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexf9oMKhLSaVNXP935TQLSHep8SbCbwF7p6yc2txOemKcMeta } from "/codebuild/output/src2003172521/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93xW0xV9rFMc0SJ1g0ts3uLrPcMlcLvcQJlG1_45vfWc6NYMeta } from "/codebuild/output/src2003172521/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexxnJCd890uLz5jSaPisQE2fqEEiyjeY7JBbVXOOyWelYMeta } from "/codebuild/output/src2003172521/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_934_z25i_27_45yoMZxDYC4HzAv1e_45Q_45UJUB9iKs1wX2blEMeta } from "/codebuild/output/src2003172521/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index9pxxGeA84bCTiDTXB7vc2eaXESE48c8p7TLW8gTyLLEMeta } from "/codebuild/output/src2003172521/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexzrkFRI7TMJYD5jWHa1HWSJAzwrmT7TsmM7QL6EIqZKoMeta } from "/codebuild/output/src2003172521/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2003172521/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2003172521/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2003172521/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2003172521/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2003172521/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexf9oMKhLSaVNXP935TQLSHep8SbCbwF7p6yc2txOemKcMeta || {},
    component: () => import("/codebuild/output/src2003172521/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2003172521/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexxnJCd890uLz5jSaPisQE2fqEEiyjeY7JBbVXOOyWelYMeta || {},
    component: () => import("/codebuild/output/src2003172521/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2003172521/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index9pxxGeA84bCTiDTXB7vc2eaXESE48c8p7TLW8gTyLLEMeta || {},
    component: () => import("/codebuild/output/src2003172521/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexzrkFRI7TMJYD5jWHa1HWSJAzwrmT7TsmM7QL6EIqZKoMeta || {},
    component: () => import("/codebuild/output/src2003172521/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]